import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../twc.refresh-layer-plugin.service';
import { WINTER_RADAR_OVERLAY_LEGEND } from './winter-radar-overlay.legend';
import { WINTER_RADAR_OVERLAY_PRODUCT_DATA } from './winter-radar-overlay.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class WinterRadarOverlayPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);
  plugin$ = this._twcPluginService.create(WINTER_RADAR_OVERLAY_PRODUCT_DATA, {
    legend: WINTER_RADAR_OVERLAY_LEGEND,
    twcLayerTypes: ['web-tile']
  });
}
